import {Injectable} from '@angular/core';
import {HttpCommonService} from "./http-common.service";
import {Observable} from "rxjs/Observable";

@Injectable()
export class EnterpPortraitService {

  constructor(private http: HttpCommonService) {
  }

  /**
   * 获取画像简介数据
   * @returns {Observable<any>}
   */
  getPortraitInfo(companyId:string):Observable<any>{
    return this.http.get('/enterprise/detail/xhsRest/enterPortrait/enterPortraitIndex',{companyId:companyId});
  }

  /**
   * 获取当前企业在行业和区域中的百分比
   * @returns {Observable<any>}
   */
  getPercent(companyId:string):Observable<any>{
    return this.http.get('/enterprise/detail/xhsRest/enterPortrait/getPercent',{companyId:companyId});
  }

  /**
   * 获取分数雷达图数据
   * @returns {Observable<any>}
   */
  getScoreRadarData(companyId:string):Observable<any>{
    return this.http.get('/enterprise/detail/xhsRest/enterPortrait/getLeiDaDatas',{companyId:companyId});
  }

  /**
   * 获取行业排名图数据
   * @returns {Observable<any>}
   */
  getIndustryRankData(companyId:string):Observable<any>{
    return this.http.get('/enterprise/detail/xhsRest/enterPortrait/getIndustryRanking',{companyId:companyId});
  }

  /**
   * 获取地区排名图数据
   * @returns {Observable<any>}
   */
  getAreaRankData(companyId:string):Observable<any>{
    return this.http.get('/enterprise/detail/xhsRest/enterPortrait/getAreaRanking',{companyId:companyId});
  }

  /**
   * 计算并查询指定企业的信用分
   * @param {string} companyId
   * @returns {Observable<any>}
   */
  calcScore(companyId:string):Observable<any>{
    return this.http.get('/enterprise/detail/credit/score/calcScore',{companyId:companyId});
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/enterp-portrait.service.ts